import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import Styles from './GenerateCards.style';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedTemplate, resetSubTempates } from '../Template.actions';
import { saveItemShareStatus } from '../../Preview/Preview.actions';
import Tag from './Tag.component';
import { CHARTER_ONLY_TEMPLATE_HEADER, CHARTER1, ONLY } from 'constants/constant';
import { getTmplName } from 'helper/utils';

import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';

const GenerateCards = (props) => {
	const { setShow, templateData, searchDatasetText = null } = props;
	const maxMeduimScreen = useMediaQuery('(max-width:1024px)');
	const minMeduimScreen = useMediaQuery('(min-width: 768px)');
	const classes = Styles({ maxMeduimScreen, minMeduimScreen });
	const [cards, setCards] = useState([]);
	const [disabledCards, setDisabledCards] = useState([]);
	const dispatch = useDispatch();

	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);

	useEffect(() => {
		setCardsDataFromTemplateData(templateData);
	}, [templateData]);

	useEffect(() => {
		if (searchDatasetText && templateData) {
			const filteredList = templateData.filter((item) => {
				if (item.templateName?.toLocaleLowerCase().includes(searchDatasetText.toLocaleLowerCase()))
					return item;
			});
			setCardsDataFromTemplateData(filteredList);
		} else setCardsDataFromTemplateData(templateData);
	}, [searchDatasetText]);

	const setCardsDataFromTemplateData = (templateData) => {
		/* istanbul ignore else */
		if (templateData?.length !== 0) {
			const cardList = [];
			const disableCardList = [];
			templateData?.forEach((item) => {
				//adding this condition to filter out custom datasets
				if (item.templateName) {
					if (item?.isDisabled) {
						disableCardList.push({
							cardTitle: item.templateName,
							cardDesc: item.templateDesc,
							templateId: item.templateId,
							view: item.view,
							filter: item.filter,
							filterWeekly: item.filterWeekly,
							templateVersion: item.templateVersion,
							filterWeeklyMultiWindow: item.filterWeeklyMultiWindow,
							isDisabled: item?.isDisabled
						});
					} else {
						cardList.push({
							cardTitle: item.templateName,
							cardDesc: item.templateDesc,
							templateId: item.templateId,
							view: item.view,
							filter: item.filter,
							filterWeekly: item.filterWeekly,
							templateVersion: item.templateVersion,
							filterWeeklyMultiWindow: item.filterWeeklyMultiWindow,
							isDisabled: item?.isDisabled
						});
					}
				}
			});
			setCards(cardList);
			setDisabledCards(disableCardList);
		} else {
			setCards([]);
			setDisabledCards([]);
		}
	};

	const onCardClick = (id, view, filter, filterWeekly, filterWeeklyMultiWindow) => {
		dispatch(resetSubTempates());
		dispatch(
			setSelectedTemplate({
				templateId: id,
				view: view,
				filter: filter,
				filterWeekly: filterWeekly,
				filterWeeklyMultiWindow: filterWeeklyMultiWindow
			})
		);
		dispatch(saveItemShareStatus({ prev: false, curr: false }));
		setShow(true);
		// Adobe analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.SELECT_TEMPLATE_BTN} ${getTmplName(id)}`,
			location: PAGE_ID.TEMPLATES
		});
	};

	const getCards = (cardsList) => {
		return (
			<Grid container spacing={3} className={classes.gridContainer}>
				{cardsList.map((item) => (
					<Grid
						item
						xs={12}
						sm={12}
						md={6}
						lg={4}
						key={`templateGrid_${item.templateId}`}
						className={classes.minWidthCard}>
						<Card
							id={`template_${item.templateId}`}
							variant="outlined"
							key={item.templateId}
							role="button"
							tabIndex={0}
							className={
								item.cardTitle === getTmplName(selectedTemplate)
									? classes.activeBorder
									: classes.inActiveBorder
							}
							onKeyDown={(e) => {
								return e.key === 'Enter'
									? onCardClick(
											item.templateId,
											item.view,
											item.filter,
											item.filterWeekly,
											item.filterWeeklyMultiWindow
									  )
									: null;
							}}
							onClick={() =>
								onCardClick(
									item.templateId,
									item.view,
									item.filter,
									item.filterWeekly,
									item.filterWeeklyMultiWindow
								)
							}>
							<Box className={classes.itemContainer}>
								<Box style={{ display: 'flex' }}>
									<Typography className={classes.title}>{item.cardTitle}</Typography>
									{/* Charter only or Enhanced tag */}
									<Tag item={item} />
								</Box>
								<Typography className={classes.descrption}>{item.cardDesc}</Typography>
							</Box>
						</Card>
					</Grid>
				))}
			</Grid>
		);
	};

	return (
		<>
			{getCards(cards)}
			{disabledCards.length > 0 && (
				<>
					<Typography className={classes.charterOnlyHeader}>
						{CHARTER_ONLY_TEMPLATE_HEADER}{' '}
						<span className={classes.charterOnlyText}>{CHARTER1}</span>
						{ONLY}
					</Typography>
					{getCards(disabledCards)}
				</>
			)}
		</>
	);
};

GenerateCards.propTypes = {
	setShow: PropTypes.func.isRequired
};

export default GenerateCards;
